/**
 * @module editablefield/editablefieldcommand
 */

import { Command } from 'ckeditor5/src/core';
import { first } from 'ckeditor5/src/utils';
import { getAndUpdateFieldId } from './utils';

const EDITABLE_FIELD = 'editablefield';

/**
 * The editablefield command.
 *
 * @extends {Command}
 */
export default class EditableFieldCommand extends Command {

	constructor( editor ) {
		super( editor );
		this.set( 'placeholder', undefined );
		this.set( 'element', undefined );
	}

	/**
	 * @inheritDoc
	 */
	refresh() {
		const model = this.editor.model;
		const selection = model.document.selection;

		this.value = null;
		this.placeholder = null;
		this.element = null;

		let allowed = false;
		if ( selection.rangeCount === 1 ) {
			const range = selection.getFirstRange();
			if ( range.isCollapsed ) {
				const block = first( selection.getSelectedBlocks() );
				allowed = !!block && model.schema.checkChild( block, EDITABLE_FIELD );
			} else {
				const items = selection.getFirstRange().getItems();
				const item = items.next().value;
				if ( item && items.next().done ) {
					if ( item.is( 'element', EDITABLE_FIELD ) ) {
						allowed = true;
						this.element = item;
						this.value = this.element.getAttribute( 'value' );
						this.placeholder = this.element.getAttribute( 'placeholder' );
					} else {
						allowed = item.is( '$textProxy' );
					}
				}
			}
		}
		this.isEnabled = allowed;
	}

	/**
	 * Executes the command.
	 *
	 * @fires execute
	 * @param {Object} attributes
	 * @param {string} [attributes.value] value of the field.
	 * @param {string} [attributes.placeholder] placeholder of the field.
	 */
	execute( attributes ) {
		const model = this.editor.model;
		const selection = model.document.selection;

		model.change( writer => {
			if ( this.element ) {
				writer.setAttributes( attributes, this.element );
			} else {
				let text;
				if ( !selection.isCollapsed ) {
					text = selection.getFirstRange().getItems().next().value.data || '';
					model.deleteContent( selection );
				} else {
					text = '';
				}

				attributes.fieldId = getAndUpdateFieldId();
				attributes.value = attributes.value || text;
				attributes.placeholder = attributes.placeholder || '';

				const node = writer.createElement( EDITABLE_FIELD, attributes );
				writer.insert( node, selection.getFirstPosition() );
				writer.setSelection( node, 'on' );
			}
		} );
	}
}
